import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M441.412 140.235v338.781c0 18.219-14.778 32.983-32.983 32.983H103.572c-18.219 0-32.983-14.764-32.983-32.983V32.983C70.588 14.764 85.352 0 103.572 0h197.605l140.235 140.235z" fill="#518ef8"/>
        <g fill="#fff">
            <path d="M161.18 257.054h189.626v21.071H161.18zM161.18 304.112h189.626v21.071H161.18zM161.18 351.171h189.626v21.071H161.18zM161.18 398.23h134.855v21.071H161.18z"/>
        </g>
        <path fill="#3a5bbc" d="M320.31 137.188l121.102 49.891v-46.844l-68.661-20.273z"/>
        <path d="M441.412 140.235H334.16c-18.22 0-32.983-14.764-32.983-32.983V0l140.235 140.235z" fill="#acd1fc"/>
    </svg>
)

export default class IconGoogleDocument extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
